import { useWindowSize } from '@uidotdev/usehooks';
import React from 'react';

export enum USE_SCREEN_DETECTOR_TYPES {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export function useScreenDetector(payload?: {
  onResize?: (size: { width?: number | null; height?: number | null }) => void;
}) {
  const size = useWindowSize();
  const [type, setType] = React.useState<USE_SCREEN_DETECTOR_TYPES | null>(null);

  // Detect if it's an actual mobile device (not just small screen)
  const [isActualMobileDevice, setIsActualMobileDevice] = React.useState(false);

  React.useEffect(() => {
    // Detect touch capability and mobile features
    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const hasMobileFeatures = 'orientation' in window;
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;

    setIsActualMobileDevice(hasTouch && (mobileRegex.test(userAgent) || hasMobileFeatures));
  }, []);

  React.useEffect(() => {
    payload?.onResize?.(size);

    if (!size?.width) {
      return;
    }

    if (size.width < 768) {
      setType(USE_SCREEN_DETECTOR_TYPES.MOBILE);
    } else if (size.width >= 768 && size.width < 1024) {
      setType(USE_SCREEN_DETECTOR_TYPES.TABLET);
    } else {
      setType(USE_SCREEN_DETECTOR_TYPES.DESKTOP);
    }
  }, [size, payload]);

  return {
    type,
    isMobile: type === USE_SCREEN_DETECTOR_TYPES.MOBILE,
    isTablet: type === USE_SCREEN_DETECTOR_TYPES.TABLET,
    isDesktop: type === USE_SCREEN_DETECTOR_TYPES.DESKTOP,
    isActualMobileDevice, // true if it's a real mobile device (touch + UA)
    isTouchDevice: isActualMobileDevice,
    width: size.width,
    height: size.height,
  };
}
